var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkItem"},[_c('span',{staticClass:"item icon",on:{"click":_vm.checkedItem}},[_c('div',{staticClass:"colorCheck",style:({'background':_vm.checked?_vm.color:'transparent'})})]),_c('span',{staticClass:"item label",on:{"click":_vm.checkedItem}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }